//@flow
import React from "react";
import { useLocalDate } from "hooks";
import { userLanguage } from "data/storeHelper";
import { getDisplayName } from "data/constants";
import Status from "components/Status";
import Constants from "data/constants";

const Dayjs = (WrappedComponent: ComponentType<any>) => {
    function LocalDate(props: any) {
        const status = useLocalDate(userLanguage());
        return status === Constants.OK ? (
            <WrappedComponent {...props} />
        ) : (
            <Status status={status} inline={true} />
        );
    }
    LocalDate.displayName = `LocalDate(${getDisplayName(WrappedComponent)})`;
    return LocalDate;
};

export default Dayjs;
